<template>
  <Link
    ref="linkRef"
    v-if="params.value?.title"
    :href="params.value.url"
    class="font-semibold text-blue-600 hover:text-blue-600"
  >
    {{ params.value.title }}
  </Link>
  <span v-else>N/A</span>
</template>

<script setup>
import { ref } from 'vue'
import { Link } from '@inertiajs/vue3'
import { useStopPropagation } from '@/Composables/stop-propagation'

const linkRef = ref(null)

// @Note:
// - Prevents panel from opening when clicking link.
// - Prevents AG Grid from showing its custom right-click menu.
useStopPropagation({ linkRef })

/**
 * @typedef {Object} ResourceType
 * @property {String} title
 * @property {String} url
 *
 * @typedef {Object} ActivityResourceTypeCellParams
 * @property {ResourceType} value
 */
const props = defineProps({
  /** @type {ActivityResourceTypeCellParams} */
  params: {
    type: Object,
    required: true
  }
})
</script>
